/* eslint-disable no-unused-vars */
import MonitorsView from './view'
import MonitorsController from './controller'
import { Helmet } from 'react-helmet'

export default function Monitors() {
  return (
    <MonitorsController>
      <Helmet>
        <title>Nomos - Monitores</title>
      </Helmet>
      <MonitorsView />
    </MonitorsController>
  )
}
